import React from 'react'
import GoogleLogin from "react-google-login";
import {SOCIAL_AUTH_PROVIDER_GOOGLE} from "../../../../constants/SocialAuthProviderConstant";
import {connect} from "react-redux";
import {socialLogin} from "../../../../actions/UserActions";
import LoginButton from "./LoginButton";
import {Trans} from "react-i18next";

class GoogleLoginButton extends LoginButton {

    handleSuccess = response => {
        const {socialLogin} = this.props;
        const {profileObj: {email, name}, googleId, accessToken} = response;

        const socialLoginForm = this.getSocialLoginForm({
            email: email,
            name: name,
            provider: SOCIAL_AUTH_PROVIDER_GOOGLE,
            access_token: accessToken,
            social_id: googleId,
            additional_data: JSON.stringify({}),
        });

        socialLogin(socialLoginForm);
    };

    handleFailure = response => {
        console.log(response);
    };

    render() {
        const {clientId} = this.props;

        return <GoogleLogin
            onSuccess={this.handleSuccess}
            onFailure={this.handleFailure}
            clientId={clientId}
            render={renderProps => (
                <a onClick={renderProps.onClick} className="btn-login google">
                    <img src="/_core/assets/themes/transcription/assets/img/transcription/google.svg" alt="Log IN with Google"/>
                    <Trans>Log IN with Google</Trans>
                </a>
            )}
        />
    }
}

export default connect(
    state => ({
        clientId: state.site.googleAppId,
    }),
    dispatch => ({
        socialLogin: formData => dispatch(socialLogin(formData))
    })
)(GoogleLoginButton)